import React from 'react';

const Home = () =>(
    <section className="mb-6">
        <h3 className="mb-2 text-xl">C:\Users\Guest\Hi.txt</h3>

        <div className="sunken-panel text-center bg-white p-4">
            <h1 className="text-3xl font-bold mb-2">Ian Dunn</h1>
            <p className="mb-4 text-base">
                <strong>Software Developer</strong>
            </p>
            <p className="mb-6">
                I love transforming visions to reality.
            </p>

            <div className="flex justify-center gap-3">
                <p className="italic">Interested in my work?</p>
                <a href="mailto:iancdunnn@gmail.com" className="no-underline">
                    <button className="font-bold px-4 py-1">Contact Me</button>
                </a>
            </div>
        </div>
    </section>
);

export default Home;